'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fasl';
var iconName = 'joystick';
var width = 448;
var height = 512;
var aliases = [128377];
var unicode = 'f8c5';
var svgPathData = 'M224 0c61.9 0 112 50.1 112 112 0 56.4-41.7 103.1-96 110.8l0 129.2 208 0 0 160-448 0 0-160 208 0 0-129.2c-54.3-7.8-96-54.4-96-110.8 0-61.9 50.1-112 112-112zM32 480l384 0 0-96-384 0 0 96zM224 32a80 80 0 1 0 0 160 80 80 0 1 0 0-160zm-16 72a24 24 0 1 1 0-48 24 24 0 1 1 0 48z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faJoystick = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;